import { z } from 'zod';

export const CoreS3FileUsageSchema = z.enum(['Permits','CE','CRM','InspectionItemCommentAttachments','InspectionAttachmentVideoOriginal','SiteAssets','NotifyVoiceResources','NotifySocialMediaImages','NotifyIntegrationProfileImages']);

export type CoreS3FileUsageType = `${z.infer<typeof CoreS3FileUsageSchema>}`

export default CoreS3FileUsageSchema;
